import {styled} from "@mui/material/styles"
import {InputLabel} from "@mui/material"

export const SortInput = styled(InputLabel)`
    transform: translate(-0.3125rem, 0.625rem) translateX(-100%) scale(1);
    padding-inline-end: 0.5rem;
    top: -2px;
    && {
        color: ${({theme}) => theme.colours.palette.text.secondary};
        font-size: ${({theme}) => theme.colours.components.inputLabel2.fontSize};
        font-weight: ${({theme}) => theme.colours.components.inputLabel2.fontWeight};
    }
`
